// The POS model and vendor a terminal's serialId encodes. serialId is `serial|vendorDigit|typeDigit`
// (BackEnd merchant_pos_contract_util.toPosRecord), so each is a single digit parsed off the key —
// 0 when the key was too short to carry one, and never validated against these names on chain.
export const POS_TYPE_MAP = {
  ME60: 1,
  SP880: 2,
  SP930: 3,
  Android: 4,
} as const;

export const POS_VENDOR_MAP = {
  NewLand: 1,
} as const;

const byDigit = (map: Record<string, number>): Record<number, string> =>
  Object.fromEntries(Object.entries(map).map(([name, digit]) => [digit, name]));

const POS_TYPE_BY_DIGIT = byDigit(POS_TYPE_MAP);
const POS_VENDOR_BY_DIGIT = byDigit(POS_VENDOR_MAP);

// 0 means the serialId carried no digit — "not specified", so an em dash like every other
// inapplicable field. A digit we have no name for is different and worth surfacing: the chain
// validates only that it is 0-9, so an unrecognised one means real hardware this map does not know.
const name = (byDigit: Record<number, string>, digit: number): string =>
  digit === 0 ? "—" : (byDigit[digit] ?? "Unknown");

/** The model name for a type digit. */
export const posTypeName = (digit: number): string =>
  name(POS_TYPE_BY_DIGIT, digit);

/** The vendor name for a vendor digit. */
export const posVendorName = (digit: number): string =>
  name(POS_VENDOR_BY_DIGIT, digit);
